import { FC } from 'react';
import { BaseError } from './BaseError';
import frameSix from 'assets/images/not_found.svg';

const errorLargeKey = 'error.not_found_error.large_text';

export const NotFoundError: FC<{}> = () => (
    <BaseError iconUrl={frameSix} keyLarge={errorLargeKey} keySmall={''} />
);
